// extracted by mini-css-extract-plugin
export default {"firing":"styles_firing__TkHPP","pewpew":"styles_pewpew__Kq7A+","lowMag":"styles_lowMag__iVx5v","emptyMag":"styles_emptyMag__u29zf","baReached":"styles_baReached__PPyp1"};